export const WORKOUT_STYLES = [
    "Crawl", "Costas", "Peito", "Borboleta", "Livre", "Medley", "Perna", "Braço", "Educativo"
];

export const WORKOUT_INTENSITIES = [
    "A1", "A2", "A3", "AN", "VO2", "Máximo", "Leve", "Moderado", "Forte"
];

export const BLOCK_NAMES = [
    "Aquecimento", "Principal", "Soltura", "Educativo", "Técnica", "Velocidade", "Resistência", "Livre"
];
